import request from "./request";
import api_config from "./api_config";
import support from "@/api/support";
import enterprise from "@/api/enterprise";
import basic from "@/api/basic";
import stock from "@/api/stock";
import flow from "@/api/flow";
import exportCenter from "@/api/exportCenter";
import order from "@/api/order";
import upload from "@/api/upload";
import prescription from "@/api/prescription";

const apiMediator = () => {
  return {
    support: support(request, api_config.identity),
    enterprise: enterprise(request, api_config.identity),
    basic: basic(request, api_config.identity),
    stock: stock(request, api_config.identity),
    flow: flow(request, api_config.identity),
    exportCenter: exportCenter(request, api_config.identity),
    order: order(request, api_config.identity),
    upload: upload(request, api_config.uploadUrl),
    prescription: prescription(request, api_config.identity),
  };
};

export default apiMediator;
